// Source of Truth for Skills and Drills Timing
// Generated from actual audio file durations
// Last updated: 2025-08-26T22:32:57.070Z

export const drillTiming = {
  "intros": {
    "soccer_drill_2011": 17,
    "soccer_drill_2012": 17,
    "soccer_drill_2013": 21,
    "soccer_drill_2014": 18,
    "soccer_drill_2015": 18,
    "soccer_drill_2016": 18,
    "soccer_drill_2017": 16,
    "soccer_drill_2018": 15,
    "soccer_drill_2019": 17,
    "soccer_drill_2020": 17,
    "soccer_drill_2021": 17,
    "soccer_drill_2022": 20,
    "basketball_drill_2001": 19,
    "basketball_drill_2002": 18,
    "basketball_drill_2003": 19,
    "basketball_drill_2004": 13,
    "basketball_drill_2005": 14,
    "basketball_drill_2006": 14,
    "basketball_drill_2007": 21,
    "basketball_drill_2008": 15,
    "basketball_drill_2009": 21,
    "basketball_drill_2010": 17,
    "karate_drill_2031": 16,
    "karate_drill_2032": 16,
    "karate_drill_2033": 14,
    "karate_drill_2034": 16,
    "karate_drill_2035": 22,
    "karate_drill_2036": 14,
    "karate_drill_2037": 16,
    "karate_drill_2038": 20,
    "karate_drill_2039": 18,
    "karate_drill_2040": 20,
    "volleyball_drill_2051": 26,
    "volleyball_drill_2052": 29,
    "volleyball_drill_2053": 28,
    "volleyball_drill_2054": 27,
    "volleyball_drill_2055": 29,
    "volleyball_drill_2056": 29,
    "volleyball_drill_2057": 28,
    "volleyball_drill_2058": 33,
    "volleyball_drill_2059": 32,
    "volleyball_drill_2060": 33,
    "movement-coordination_drill_2061": 20,
    "movement-coordination_drill_2062": 21,
    "movement-coordination_drill_2063": 21,
    "movement-coordination_drill_2064": 21,
    "movement-coordination_drill_2065": 20,
    "movement-coordination_drill_2066": 21,
    "movement-coordination_drill_2067": 22,
    "movement-coordination_drill_2068": 23,
    "movement-coordination_drill_2069": 20,
    "running-technique_drill_2110": 15,
    "running-technique_drill_2113": 17,
    "running-technique_drill_2116": 16,
    "running-technique_drill_2117": 19,
    "dance_drill_2041": 14,
    "dance_drill_2042": 16,
    "dance_drill_2043": 15,
    "dance_drill_2044": 13,
    "dance_drill_2045": 12,
    "dance_drill_2046": 16,
    "dance_drill_2047": 15,
    "dance_drill_2048": 19,
    "dance_drill_2049": 19,
    "dance_drill_2050": 17,
    "ballet_drill_2190": 14,
    "ballet_drill_2191": 16,
    "ballet_drill_2192": 16,
    "ballet_drill_2193": 15,
    "ballet_drill_2194": 16,
    "ballet_drill_2195": 16,
    "ballet_drill_2196": 14,
    "ballet_drill_2197": 16,
    "ballet_drill_2198": 15,
    "ballet_drill_2199": 15,
    "yoga_drill_2100": 15,
    "yoga_drill_2101": 16,
    "yoga_drill_2102": 16,
    "taekwondo_drill_2120": 15,
    "taekwondo_drill_2121": 17,
    "taekwondo_drill_2122": 16,
    "taekwondo_drill_2123": 16,
    "taekwondo_drill_2124": 15,
    "taekwondo_drill_2125": 17,
    "taekwondo_drill_2126": 16,
    "taekwondo_drill_2127": 16,
    "taekwondo_drill_2128": 15,
    "taekwondo_drill_2129": 15,
    "taekwondo_drill_2130": 16,
    "baseball_drill_2140": 16,
    "baseball_drill_2141": 19,
    "baseball_drill_2142": 22,
    "baseball_drill_2143": 20,
    "baseball_drill_2144": 17,
    "baseball_drill_2145": 28,
    "baseball_drill_2146": 19,
    "baseball_drill_2147": 21,
    "baseball_drill_2148": 19,
    "baseball_drill_2149": 18
  },
  "instructions": {
    "soccer_drill_2011": 1075,
    "soccer_drill_2012": 1376,
    "soccer_drill_2013": 1351,
    "soccer_drill_2014": 1637,
    "soccer_drill_2015": 1220,
    "soccer_drill_2016": 1454,
    "soccer_drill_2017": 954,
    "soccer_drill_2018": 1493,
    "soccer_drill_2019": 1437,
    "soccer_drill_2020": 1602,
    "soccer_drill_2021": 1601,
    "soccer_drill_2022": 434,
    "basketball_drill_2001": 259,
    "basketball_drill_2002": 424,
    "basketball_drill_2003": 461,
    "basketball_drill_2004": 346,
    "basketball_drill_2005": 385,
    "basketball_drill_2006": 538,
    "basketball_drill_2007": 565,
    "basketball_drill_2008": 597,
    "basketball_drill_2009": 591,
    "basketball_drill_2010": 1081,
    "karate_drill_2031": 1466,
    "karate_drill_2032": 1357,
    "karate_drill_2033": 1327,
    "karate_drill_2034": 1282,
    "karate_drill_2035": 1372,
    "karate_drill_2036": 1436,
    "karate_drill_2037": 1303,
    "karate_drill_2038": 1355,
    "karate_drill_2039": 1376,
    "karate_drill_2040": 1414,
    "volleyball_drill_2051": 366,
    "volleyball_drill_2052": 438,
    "volleyball_drill_2053": 444,
    "volleyball_drill_2054": 344,
    "volleyball_drill_2055": 447,
    "volleyball_drill_2056": 424,
    "volleyball_drill_2057": 348,
    "volleyball_drill_2058": 409,
    "volleyball_drill_2059": 380,
    "volleyball_drill_2060": 524,
    "movement-coordination_drill_2061": 353,
    "movement-coordination_drill_2062": 499,
    "movement-coordination_drill_2063": 507,
    "movement-coordination_drill_2064": 238,
    "movement-coordination_drill_2065": 260,
    "movement-coordination_drill_2066": 389,
    "movement-coordination_drill_2067": 563,
    "movement-coordination_drill_2068": 507,
    "movement-coordination_drill_2069": 582,
    "running-technique_drill_2110": 446,
    "running-technique_drill_2113": 404,
    "running-technique_drill_2116": 462,
    "running-technique_drill_2117": 406,
    "martial-arts_drill_2021": 1038,
    "martial-arts_drill_2022": 1039,
    "martial-arts_drill_2023": 570,
    "martial-arts_drill_2024": 1078,
    "martial-arts_drill_2025": 942,
    "martial-arts_drill_2026": 1363,
    "martial-arts_drill_2027": 906,
    "martial-arts_drill_2028": 1352,
    "martial-arts_drill_2029": 1305,
    "martial-arts_drill_2030": 728,
    "dance_drill_2041": 500,
    "dance_drill_2042": 366,
    "dance_drill_2043": 569,
    "dance_drill_2044": 540,
    "dance_drill_2045": 472,
    "dance_drill_2046": 521,
    "dance_drill_2047": 369,
    "dance_drill_2048": 329,
    "dance_drill_2049": 343,
    "dance_drill_2050": 363,
    "ballet_drill_2190": 690,
    "ballet_drill_2191": 580,
    "ballet_drill_2192": 577,
    "ballet_drill_2193": 452,
    "ballet_drill_2194": 493,
    "ballet_drill_2195": 555,
    "ballet_drill_2196": 525,
    "ballet_drill_2197": 495,
    "ballet_drill_2198": 505,
    "ballet_drill_2199": 652,
    "boxing_drill_2090": 551,
    "boxing_drill_2091": 663,
    "boxing_drill_2092": 446,
    "boxing_drill_2093": 149,
    "boxing_drill_2094": 860,
    "boxing_drill_2095": 698,
    "boxing_drill_2096": 1197,
    "boxing_drill_2097": 159,
    "boxing_drill_2098": 1159,
    "boxing_drill_2099": 1086,
    "yoga_drill_2100": 721,
    "yoga_drill_2101": 973,
    "yoga_drill_2102": 958,
    "taekwondo_drill_2120": 483,
    "taekwondo_drill_2121": 450,
    "taekwondo_drill_2122": 944,
    "taekwondo_drill_2123": 1031,
    "taekwondo_drill_2124": 580,
    "taekwondo_drill_2125": 583,
    "taekwondo_drill_2126": 896,
    "taekwondo_drill_2127": 901,
    "taekwondo_drill_2128": 648,
    "taekwondo_drill_2129": 198,
    "taekwondo_drill_2130": 680,
    "baseball_drill_2140": 303,
    "baseball_drill_2141": 262,
    "baseball_drill_2142": 282,
    "baseball_drill_2143": 287,
    "baseball_drill_2144": 259,
    "baseball_drill_2145": 510,
    "baseball_drill_2146": 268,
    "baseball_drill_2147": 242,
    "baseball_drill_2148": 275,
    "baseball_drill_2149": 278
  }
};

export const partnerDrillTiming = {
  "intros": {
    "soccer_partner_drill_2170": 13,
    "soccer_partner_drill_2171": 19,
    "soccer_partner_drill_2172": 19,
    "soccer_partner_drill_2173": 16,
    "soccer_partner_drill_2174": 18,
    "soccer_partner_drill_2175": 19,
    "soccer_partner_drill_2176": 17,
    "soccer_partner_drill_2177": 18,
    "soccer_partner_drill_2178": 19,
    "soccer_partner_drill_2179": 18,
    "soccer_partner_drill_2180": 18,
    "soccer_partner_drill_2181": 19,
    "volleyball_partner_drill_2080": 26,
    "volleyball_partner_drill_2081": 25,
    "volleyball_partner_drill_2082": 24,
    "volleyball_partner_drill_2083": 24,
    "volleyball_partner_drill_2084": 27,
    "volleyball_partner_drill_2085": 26,
    "volleyball_partner_drill_2086": 27,
    "volleyball_partner_drill_2087": 28,
    "volleyball_partner_drill_2088": 27,
    "volleyball_partner_drill_2089": 24,
    "baseball_partner_drill_2160": 21,
    "baseball_partner_drill_2161": 15,
    "baseball_partner_drill_2162": 18,
    "baseball_partner_drill_2163": 20,
    "baseball_partner_drill_2164": 18,
    "baseball_partner_drill_2165": 20
  },
  "instructions": {
    "soccer_partner_drill_2170": 1210,
    "soccer_partner_drill_2171": 1485,
    "soccer_partner_drill_2172": 1423,
    "soccer_partner_drill_2173": 1393,
    "soccer_partner_drill_2174": 1455,
    "soccer_partner_drill_2175": 1612,
    "soccer_partner_drill_2176": 1324,
    "soccer_partner_drill_2177": 1344,
    "soccer_partner_drill_2178": 458,
    "soccer_partner_drill_2179": 1804,
    "soccer_partner_drill_2180": 1964,
    "soccer_partner_drill_2181": 1947,
    "volleyball_partner_drill_2080": 384,
    "volleyball_partner_drill_2081": 394,
    "volleyball_partner_drill_2082": 418,
    "volleyball_partner_drill_2083": 385,
    "volleyball_partner_drill_2084": 424,
    "volleyball_partner_drill_2085": 416,
    "volleyball_partner_drill_2086": 362,
    "volleyball_partner_drill_2087": 405,
    "volleyball_partner_drill_2088": 427,
    "volleyball_partner_drill_2089": 472,
    "baseball_partner_drill_2160": 501,
    "baseball_partner_drill_2161": 408,
    "baseball_partner_drill_2162": 460,
    "baseball_partner_drill_2163": 597,
    "baseball_partner_drill_2164": 863,
    "baseball_partner_drill_2165": 325
  }
};

export const skillTiming = {
  "intros": {},
  "completions": {}
};

export const drillTimingData = {
  "2001": {
    "introTime": 19,
    "instructionTime": 259,
    "totalTime": 278,
    "totalMinutes": 5
  },
  "2002": {
    "introTime": 18,
    "instructionTime": 424,
    "totalTime": 442,
    "totalMinutes": 7
  },
  "2003": {
    "introTime": 19,
    "instructionTime": 461,
    "totalTime": 480,
    "totalMinutes": 8
  },
  "2004": {
    "introTime": 13,
    "instructionTime": 346,
    "totalTime": 359,
    "totalMinutes": 6
  },
  "2005": {
    "introTime": 14,
    "instructionTime": 385,
    "totalTime": 399,
    "totalMinutes": 7
  },
  "2006": {
    "introTime": 14,
    "instructionTime": 538,
    "totalTime": 552,
    "totalMinutes": 9
  },
  "2007": {
    "introTime": 21,
    "instructionTime": 565,
    "totalTime": 586,
    "totalMinutes": 10
  },
  "2008": {
    "introTime": 15,
    "instructionTime": 597,
    "totalTime": 612,
    "totalMinutes": 10
  },
  "2009": {
    "introTime": 21,
    "instructionTime": 591,
    "totalTime": 612,
    "totalMinutes": 10
  },
  "2010": {
    "introTime": 17,
    "instructionTime": 1081,
    "totalTime": 1098,
    "totalMinutes": 18
  },
  "2011": {
    "introTime": 17,
    "instructionTime": 1075,
    "totalTime": 1092,
    "totalMinutes": 18
  },
  "2012": {
    "introTime": 17,
    "instructionTime": 1376,
    "totalTime": 1393,
    "totalMinutes": 23
  },
  "2013": {
    "introTime": 21,
    "instructionTime": 1351,
    "totalTime": 1372,
    "totalMinutes": 23
  },
  "2014": {
    "introTime": 18,
    "instructionTime": 1637,
    "totalTime": 1655,
    "totalMinutes": 28
  },
  "2015": {
    "introTime": 18,
    "instructionTime": 1220,
    "totalTime": 1238,
    "totalMinutes": 21
  },
  "2016": {
    "introTime": 18,
    "instructionTime": 1454,
    "totalTime": 1472,
    "totalMinutes": 25
  },
  "2017": {
    "introTime": 16,
    "instructionTime": 954,
    "totalTime": 970,
    "totalMinutes": 16
  },
  "2018": {
    "introTime": 15,
    "instructionTime": 1493,
    "totalTime": 1508,
    "totalMinutes": 25
  },
  "2019": {
    "introTime": 17,
    "instructionTime": 1437,
    "totalTime": 1454,
    "totalMinutes": 24
  },
  "2020": {
    "introTime": 17,
    "instructionTime": 1602,
    "totalTime": 1619,
    "totalMinutes": 27
  },
  "2021": {
    "introTime": 17,
    "instructionTime": 1601,
    "totalTime": 1618,
    "totalMinutes": 27
  },
  "2022": {
    "introTime": 20,
    "instructionTime": 434,
    "totalTime": 454,
    "totalMinutes": 8
  },
  "2031": {
    "introTime": 16,
    "instructionTime": 1466,
    "totalTime": 1482,
    "totalMinutes": 25
  },
  "2032": {
    "introTime": 16,
    "instructionTime": 1357,
    "totalTime": 1373,
    "totalMinutes": 23
  },
  "2033": {
    "introTime": 14,
    "instructionTime": 1327,
    "totalTime": 1341,
    "totalMinutes": 22
  },
  "2034": {
    "introTime": 16,
    "instructionTime": 1282,
    "totalTime": 1298,
    "totalMinutes": 22
  },
  "2035": {
    "introTime": 22,
    "instructionTime": 1372,
    "totalTime": 1394,
    "totalMinutes": 23
  },
  "2036": {
    "introTime": 14,
    "instructionTime": 1436,
    "totalTime": 1450,
    "totalMinutes": 24
  },
  "2037": {
    "introTime": 16,
    "instructionTime": 1303,
    "totalTime": 1319,
    "totalMinutes": 22
  },
  "2038": {
    "introTime": 20,
    "instructionTime": 1355,
    "totalTime": 1375,
    "totalMinutes": 23
  },
  "2039": {
    "introTime": 18,
    "instructionTime": 1376,
    "totalTime": 1394,
    "totalMinutes": 23
  },
  "2040": {
    "introTime": 20,
    "instructionTime": 1414,
    "totalTime": 1434,
    "totalMinutes": 24
  },
  "2041": {
    "introTime": 14,
    "instructionTime": 500,
    "totalTime": 514,
    "totalMinutes": 9
  },
  "2042": {
    "introTime": 16,
    "instructionTime": 366,
    "totalTime": 382,
    "totalMinutes": 6
  },
  "2043": {
    "introTime": 15,
    "instructionTime": 569,
    "totalTime": 584,
    "totalMinutes": 10
  },
  "2044": {
    "introTime": 13,
    "instructionTime": 540,
    "totalTime": 553,
    "totalMinutes": 9
  },
  "2045": {
    "introTime": 12,
    "instructionTime": 472,
    "totalTime": 484,
    "totalMinutes": 8
  },
  "2046": {
    "introTime": 16,
    "instructionTime": 521,
    "totalTime": 537,
    "totalMinutes": 9
  },
  "2047": {
    "introTime": 15,
    "instructionTime": 369,
    "totalTime": 384,
    "totalMinutes": 6
  },
  "2048": {
    "introTime": 19,
    "instructionTime": 329,
    "totalTime": 348,
    "totalMinutes": 6
  },
  "2049": {
    "introTime": 19,
    "instructionTime": 343,
    "totalTime": 362,
    "totalMinutes": 6
  },
  "2050": {
    "introTime": 17,
    "instructionTime": 363,
    "totalTime": 380,
    "totalMinutes": 6
  },
  "2051": {
    "introTime": 26,
    "instructionTime": 366,
    "totalTime": 392,
    "totalMinutes": 7
  },
  "2052": {
    "introTime": 29,
    "instructionTime": 438,
    "totalTime": 467,
    "totalMinutes": 8
  },
  "2053": {
    "introTime": 28,
    "instructionTime": 444,
    "totalTime": 472,
    "totalMinutes": 8
  },
  "2054": {
    "introTime": 27,
    "instructionTime": 344,
    "totalTime": 371,
    "totalMinutes": 6
  },
  "2055": {
    "introTime": 29,
    "instructionTime": 447,
    "totalTime": 476,
    "totalMinutes": 8
  },
  "2056": {
    "introTime": 29,
    "instructionTime": 424,
    "totalTime": 453,
    "totalMinutes": 8
  },
  "2057": {
    "introTime": 28,
    "instructionTime": 348,
    "totalTime": 376,
    "totalMinutes": 6
  },
  "2058": {
    "introTime": 33,
    "instructionTime": 409,
    "totalTime": 442,
    "totalMinutes": 7
  },
  "2059": {
    "introTime": 32,
    "instructionTime": 380,
    "totalTime": 412,
    "totalMinutes": 7
  },
  "2060": {
    "introTime": 33,
    "instructionTime": 524,
    "totalTime": 557,
    "totalMinutes": 9
  },
  "2061": {
    "introTime": 20,
    "instructionTime": 353,
    "totalTime": 373,
    "totalMinutes": 6
  },
  "2062": {
    "introTime": 21,
    "instructionTime": 499,
    "totalTime": 520,
    "totalMinutes": 9
  },
  "2063": {
    "introTime": 21,
    "instructionTime": 507,
    "totalTime": 528,
    "totalMinutes": 9
  },
  "2064": {
    "introTime": 21,
    "instructionTime": 238,
    "totalTime": 259,
    "totalMinutes": 4
  },
  "2065": {
    "introTime": 20,
    "instructionTime": 260,
    "totalTime": 280,
    "totalMinutes": 5
  },
  "2066": {
    "introTime": 21,
    "instructionTime": 389,
    "totalTime": 410,
    "totalMinutes": 7
  },
  "2067": {
    "introTime": 22,
    "instructionTime": 563,
    "totalTime": 585,
    "totalMinutes": 10
  },
  "2068": {
    "introTime": 23,
    "instructionTime": 507,
    "totalTime": 530,
    "totalMinutes": 9
  },
  "2069": {
    "introTime": 20,
    "instructionTime": 582,
    "totalTime": 602,
    "totalMinutes": 10
  },
  "2080": {
    "introTime": 26,
    "instructionTime": 384,
    "totalTime": 410,
    "totalMinutes": 7
  },
  "2081": {
    "introTime": 25,
    "instructionTime": 394,
    "totalTime": 419,
    "totalMinutes": 7
  },
  "2082": {
    "introTime": 24,
    "instructionTime": 418,
    "totalTime": 442,
    "totalMinutes": 7
  },
  "2083": {
    "introTime": 24,
    "instructionTime": 385,
    "totalTime": 409,
    "totalMinutes": 7
  },
  "2084": {
    "introTime": 27,
    "instructionTime": 424,
    "totalTime": 451,
    "totalMinutes": 8
  },
  "2085": {
    "introTime": 26,
    "instructionTime": 416,
    "totalTime": 442,
    "totalMinutes": 7
  },
  "2086": {
    "introTime": 27,
    "instructionTime": 362,
    "totalTime": 389,
    "totalMinutes": 6
  },
  "2087": {
    "introTime": 28,
    "instructionTime": 405,
    "totalTime": 433,
    "totalMinutes": 7
  },
  "2088": {
    "introTime": 27,
    "instructionTime": 427,
    "totalTime": 454,
    "totalMinutes": 8
  },
  "2089": {
    "introTime": 24,
    "instructionTime": 472,
    "totalTime": 496,
    "totalMinutes": 8
  },
  "2100": {
    "introTime": 15,
    "instructionTime": 721,
    "totalTime": 736,
    "totalMinutes": 12
  },
  "2101": {
    "introTime": 16,
    "instructionTime": 973,
    "totalTime": 989,
    "totalMinutes": 16
  },
  "2102": {
    "introTime": 16,
    "instructionTime": 958,
    "totalTime": 974,
    "totalMinutes": 16
  },
  "2110": {
    "introTime": 15,
    "instructionTime": 446,
    "totalTime": 461,
    "totalMinutes": 8
  },
  "2113": {
    "introTime": 17,
    "instructionTime": 404,
    "totalTime": 421,
    "totalMinutes": 7
  },
  "2116": {
    "introTime": 16,
    "instructionTime": 462,
    "totalTime": 478,
    "totalMinutes": 8
  },
  "2117": {
    "introTime": 19,
    "instructionTime": 406,
    "totalTime": 425,
    "totalMinutes": 7
  },
  "2120": {
    "introTime": 15,
    "instructionTime": 483,
    "totalTime": 498,
    "totalMinutes": 8
  },
  "2121": {
    "introTime": 17,
    "instructionTime": 450,
    "totalTime": 467,
    "totalMinutes": 8
  },
  "2122": {
    "introTime": 16,
    "instructionTime": 944,
    "totalTime": 960,
    "totalMinutes": 16
  },
  "2123": {
    "introTime": 16,
    "instructionTime": 1031,
    "totalTime": 1047,
    "totalMinutes": 17
  },
  "2124": {
    "introTime": 15,
    "instructionTime": 580,
    "totalTime": 595,
    "totalMinutes": 10
  },
  "2125": {
    "introTime": 17,
    "instructionTime": 583,
    "totalTime": 600,
    "totalMinutes": 10
  },
  "2126": {
    "introTime": 16,
    "instructionTime": 896,
    "totalTime": 912,
    "totalMinutes": 15
  },
  "2127": {
    "introTime": 16,
    "instructionTime": 901,
    "totalTime": 917,
    "totalMinutes": 15
  },
  "2128": {
    "introTime": 15,
    "instructionTime": 648,
    "totalTime": 663,
    "totalMinutes": 11
  },
  "2129": {
    "introTime": 15,
    "instructionTime": 198,
    "totalTime": 213,
    "totalMinutes": 4
  },
  "2130": {
    "introTime": 16,
    "instructionTime": 680,
    "totalTime": 696,
    "totalMinutes": 12
  },
  "2140": {
    "introTime": 16,
    "instructionTime": 303,
    "totalTime": 319,
    "totalMinutes": 5
  },
  "2141": {
    "introTime": 19,
    "instructionTime": 262,
    "totalTime": 281,
    "totalMinutes": 5
  },
  "2142": {
    "introTime": 22,
    "instructionTime": 282,
    "totalTime": 304,
    "totalMinutes": 5
  },
  "2143": {
    "introTime": 20,
    "instructionTime": 287,
    "totalTime": 307,
    "totalMinutes": 5
  },
  "2144": {
    "introTime": 17,
    "instructionTime": 259,
    "totalTime": 276,
    "totalMinutes": 5
  },
  "2145": {
    "introTime": 28,
    "instructionTime": 510,
    "totalTime": 538,
    "totalMinutes": 9
  },
  "2146": {
    "introTime": 19,
    "instructionTime": 268,
    "totalTime": 287,
    "totalMinutes": 5
  },
  "2147": {
    "introTime": 21,
    "instructionTime": 242,
    "totalTime": 263,
    "totalMinutes": 4
  },
  "2148": {
    "introTime": 19,
    "instructionTime": 275,
    "totalTime": 294,
    "totalMinutes": 5
  },
  "2149": {
    "introTime": 18,
    "instructionTime": 278,
    "totalTime": 296,
    "totalMinutes": 5
  },
  "2160": {
    "introTime": 21,
    "instructionTime": 501,
    "totalTime": 522,
    "totalMinutes": 9
  },
  "2161": {
    "introTime": 15,
    "instructionTime": 408,
    "totalTime": 423,
    "totalMinutes": 7
  },
  "2162": {
    "introTime": 18,
    "instructionTime": 460,
    "totalTime": 478,
    "totalMinutes": 8
  },
  "2163": {
    "introTime": 20,
    "instructionTime": 597,
    "totalTime": 617,
    "totalMinutes": 10
  },
  "2164": {
    "introTime": 18,
    "instructionTime": 863,
    "totalTime": 881,
    "totalMinutes": 15
  },
  "2165": {
    "introTime": 20,
    "instructionTime": 325,
    "totalTime": 345,
    "totalMinutes": 6
  },
  "2170": {
    "introTime": 13,
    "instructionTime": 1210,
    "totalTime": 1223,
    "totalMinutes": 20
  },
  "2171": {
    "introTime": 19,
    "instructionTime": 1485,
    "totalTime": 1504,
    "totalMinutes": 25
  },
  "2172": {
    "introTime": 19,
    "instructionTime": 1423,
    "totalTime": 1442,
    "totalMinutes": 24
  },
  "2173": {
    "introTime": 16,
    "instructionTime": 1393,
    "totalTime": 1409,
    "totalMinutes": 23
  },
  "2174": {
    "introTime": 18,
    "instructionTime": 1455,
    "totalTime": 1473,
    "totalMinutes": 25
  },
  "2175": {
    "introTime": 19,
    "instructionTime": 1612,
    "totalTime": 1631,
    "totalMinutes": 27
  },
  "2176": {
    "introTime": 17,
    "instructionTime": 1324,
    "totalTime": 1341,
    "totalMinutes": 22
  },
  "2177": {
    "introTime": 18,
    "instructionTime": 1344,
    "totalTime": 1362,
    "totalMinutes": 23
  },
  "2178": {
    "introTime": 19,
    "instructionTime": 458,
    "totalTime": 477,
    "totalMinutes": 8
  },
  "2179": {
    "introTime": 18,
    "instructionTime": 1804,
    "totalTime": 1822,
    "totalMinutes": 30
  },
  "2180": {
    "introTime": 18,
    "instructionTime": 1964,
    "totalTime": 1982,
    "totalMinutes": 33
  },
  "2181": {
    "introTime": 19,
    "instructionTime": 1947,
    "totalTime": 1966,
    "totalMinutes": 33
  },
  "2190": {
    "introTime": 14,
    "instructionTime": 690,
    "totalTime": 704,
    "totalMinutes": 12
  },
  "2191": {
    "introTime": 16,
    "instructionTime": 580,
    "totalTime": 596,
    "totalMinutes": 10
  },
  "2192": {
    "introTime": 16,
    "instructionTime": 577,
    "totalTime": 593,
    "totalMinutes": 10
  },
  "2193": {
    "introTime": 15,
    "instructionTime": 452,
    "totalTime": 467,
    "totalMinutes": 8
  },
  "2194": {
    "introTime": 16,
    "instructionTime": 493,
    "totalTime": 509,
    "totalMinutes": 8
  },
  "2195": {
    "introTime": 16,
    "instructionTime": 555,
    "totalTime": 571,
    "totalMinutes": 10
  },
  "2196": {
    "introTime": 14,
    "instructionTime": 525,
    "totalTime": 539,
    "totalMinutes": 9
  },
  "2197": {
    "introTime": 16,
    "instructionTime": 495,
    "totalTime": 511,
    "totalMinutes": 9
  },
  "2198": {
    "introTime": 15,
    "instructionTime": 505,
    "totalTime": 520,
    "totalMinutes": 9
  },
  "2199": {
    "introTime": 15,
    "instructionTime": 652,
    "totalTime": 667,
    "totalMinutes": 11
  }
};

// Helper function to get drill timing by ID
export const getDrillTimingById = (drillId) => {
  return drillTimingData[drillId] || null;
};

// Helper function to get skill timing by ID
export const getSkillTimingById = (skillId) => {
  return skillTiming.intros[skillId] || null;
};

// Helper function to get drill timing by name
export const getDrillTimingByName = (drillName) => {
  return {
    introTime: drillTiming.intros[drillName] || 0,
    instructionTime: drillTiming.instructions[drillName] || 0,
    totalTime: (drillTiming.intros[drillName] || 0) + (drillTiming.instructions[drillName] || 0)
  };
};

// Helper function to get partner drill timing by name
export const getPartnerDrillTimingByName = (drillName) => {
  return {
    introTime: partnerDrillTiming.intros[drillName] || 0,
    instructionTime: partnerDrillTiming.instructions[drillName] || 0,
    totalTime: (partnerDrillTiming.intros[drillName] || 0) + (partnerDrillTiming.instructions[drillName] || 0)
  };
};
